import { useState } from 'react';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

export default function InventoryImportPage() {
  const authContext = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  const handleImport = async () => {
    if (!authContext?.token) {
      setError('Please login first');
      return;
    }

    setLoading(true);
    setError(null);
    setResults(null);

    try {
      // Fetch the import data
      const importResponse = await fetch('/import-data.json');
      const importData = await importResponse.json();

      // Send to API
      const response = await fetch('/api/inventory/import', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authContext.token}`
        },
        body: JSON.stringify(importData)
      });

      const result = await response.json();
      setResults(result.data);

      if (!result.success) {
        setError(result.error);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Import failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8 max-w-2xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">استيراد بيانات المخزن</h1>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <p className="text-blue-900 text-sm">
          استيراد بيانات المخزن من ملف JSON المُعدّ مسبقاً
        </p>
      </div>

      <button
        onClick={handleImport}
        disabled={loading}
        className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 disabled:bg-gray-400"
      >
        {loading ? 'جاري الاستيراد...' : 'استيراد البيانات'}
      </button>

      {error && (
        <div className="mt-6 bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-900 font-semibold">خطأ:</p>
          <p className="text-red-800">{error}</p>
        </div>
      )}

      {results && (
        <div className="mt-6 bg-green-50 border border-green-200 rounded-lg p-4">
          <p className="text-green-900 font-semibold mb-3">✅ تم استيراد البيانات بنجاح</p>
          <div className="text-green-800 space-y-2">
            <p>المنتجات المنشأة: <span className="font-bold">{results.created_products}</span></p>
            <p>الألوان المضافة: <span className="font-bold">{results.created_variants}</span></p>
            <p>سجلات المخزن: <span className="font-bold">{results.updated_stock}</span></p>

            {results.errors && results.errors.length > 0 && (
              <div className="mt-4 pt-4 border-t border-green-300">
                <p className="text-yellow-900 font-semibold mb-2">تنبيهات:</p>
                <ul className="text-yellow-800 text-sm space-y-1">
                  {results.errors.slice(0, 5).map((err: string, i: number) => (
                    <li key={i}>• {err}</li>
                  ))}
                  {results.errors.length > 5 && (
                    <li>... و {results.errors.length - 5} أخطاء أخرى</li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
